import { render, staticRenderFns } from "./EXPermissionDeniedState.vue?vue&type=template&id=34037aa3&scoped=true"
import script from "./EXPermissionDeniedState.vue?vue&type=script&setup=true&lang=js"
export * from "./EXPermissionDeniedState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EXPermissionDeniedState.vue?vue&type=style&index=0&id=34037aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34037aa3",
  null
  
)

export default component.exports